// extracted by mini-css-extract-plugin
export default {"container":"detail_container__xf-bA","table":"detail_table__U-yF8","d-flex":"detail_d-flex__JmFYb"};